import { render, staticRenderFns } from "./DerbyABTest.vue?vue&type=template&id=b0198ba0&"
import script from "./DerbyABTest.vue?vue&type=script&lang=js&"
export * from "./DerbyABTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports